import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function CounselingDirectionIntro() {
  return <section id="counselingdirectionintro" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-12">
          <p className="text-primary font-bold font-default mb-3">Orientation</p>
          <h1 className="text-3xl md:text-4xl font-bold text-primary font-default leading-tight mb-4">カウンセリングの方向性</h1>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/11/signpost-method.jpg" alt="自然の中に立つ人と乗馬の方向を示す道標" className="w-full rounded-lg shadow-lg object-cover aspect-[4/3]" loading="lazy" />
          </div>

          <div className="order-1 lg:order-2 space-y-6">
            <p className="text-foreground leading-relaxed font-default">カウンセリングではご相談される方のお悩みや困りごとをどのように改善・解決していくか、ご相談される方とカウンセラーが話し合い、共に考えていきますが、そのための理論や技法がいくつも考えられています。</p>
            <p className="text-foreground leading-relaxed font-default">何らかの問題を改善・解決することを目的としてカウンセリングは行われ、そのための技法は様々ですが、その目的を達成するためにカウンセリングで話し合われる方向性としては大きく3つに分けられます。それは、環境調整・症状改善・自己探索の3つです。</p>
            <p className="text-foreground leading-relaxed font-default">これらの3つは技法の種類によってどれか1つが話し合いのメインになることが多いのですが、カウンセリングの過程によっては方向が変わっていったり、複数の要素が重なったりすることもあります。</p>
          </div>
        </div>
      </div>
    </section>;
}